<form [formGroup]="TrnMainForm">
    <div class="row">
        <div class="plainBackGround" style="margin-bottom:0px;">
            <label *ngIf="voucherType==18 ||voucherType==17"  style="width:9%">Voucher Type:</label>
            <label *ngIf="voucherType==15 ||voucherType==16" style="width:9%">Party Type:</label>
            <select style="width:25.7%;" formControlName="TRNMODE" (change)="VoucherTypeChangeEvent($event.target.value)">
                <option *ngIf="voucherType==18" value="Income Voucher">Income Voucher</option>
                <option *ngIf="voucherType==18" value="Party Receipt">Party Receipt</option>
                <option *ngIf="voucherType==18" value="Bank Withdraw Voucher">Bank Withdraw Voucher</option>
                <option *ngIf="voucherType==18" value="Cheque Encash">Cheque Encash</option>

                <option *ngIf="voucherType==17" value="Expenses Voucher">Expenses Voucher</option>
                <option *ngIf="voucherType==17" value="Party Payment">Party Payment</option>
                <option *ngIf="voucherType==17" value="Bank Deposit Voucher">Bank Deposit Voucher</option>
                <option *ngIf="voucherType==17" value="Cash Transfer">Cash Transfer</option>

                <option *ngIf="voucherType==15 ||voucherType==16"  value="Customer">Customer</option>
                <option *ngIf="voucherType==15 ||voucherType==16" value="Supplier">Supplier</option> 
            </select>
            
                <label *ngIf="TrnMainObj.TRNMODE=='Party Receipt' ||TrnMainObj.TRNMODE=='Income Voucher'||TrnMainObj.TRNMODE=='Expenses Voucher'||TrnMainObj.TRNMODE=='Party Payment' " style="margin-left: 5px;width: 91px">Cash/Bank:</label>
                <label *ngIf="TrnMainObj.TRNMODE=='Bank Withdraw Voucher' ||TrnMainObj.TRNMODE=='Cheque Encash' "  style="margin-left: 5px;width: 91px">Cash:</label>
                <label *ngIf="TrnMainObj.TRNMODE=='Bank Deposit Voucher'"  style="margin-left: 5px;width: 91px">Cash/Cheque:</label>
                <label *ngIf="TrnMainObj.TRNMODE=='Cash Transfer'"  style="margin-left: 5px;width: 91px">Transfer From:</label>
                <label *ngIf="voucherType==15 ||voucherType==16"  style="margin-left: 5px;width: 91px">Party:</label>
                        <select style="width:14%;" formControlName="TRNAC" (change)="acCodeChange()">
                            <option *ngFor="let code of cashAccountObserver$ | async" [ngValue]="code.ACID">{{code.ACCODE}}</option>
                        </select>
                        <select style="width:36%; margin-left: 5px;" formControlName="TRNAC" (change)="acNameChange()">
                            <option  *ngFor="let code of cashAccountObserver$ | async" [ngValue]="code.ACID">{{code.ACNAME}}</option>
                        </select>
            <div class="form-inline" *ngIf="voucherType==18 ||voucherType==17">
                <label style="width: 9%" *ngIf="voucherType==18">Received From :</label>
                <label style="width: 9%" *ngIf="voucherType==17">Pay To :</label>
                <input type="text" style="width:25.7%;padding-left:4px" formControlName="BILLTO" *ngIf="voucherType==18" placeholder="Received From">
                <input type="text" style="width:25.7%;padding-left:4px" formControlName="BILLTO" *ngIf="voucherType==17" placeholder="Pay To">
                
                <label style="margin-left: 5px; width:91px">Cheque No.:</label>
                <input type="text" style="width:28.1%;padding-left:4px" formControlName="CHEQUENO" placeholder="Cheque No.">
                
                <label style="margin-left: 5px">Cheque Date: </label>
                <input type="date" style="margin-right: 5px;width:13%;" formControlName="CHEQUEDATE">
            </div>
        
            <label style="width:9%">Narration :</label>
            <input style="width:86.3%; padding-left:4px"  type="text" formControlName="REMARKS" placeholder="Narration">
        </div>
    </div>
</form>
<!--<div class="row" style="margin: 0px"> 
    <trntranentry [voucherType]="voucherType" [TrnTranList]="TrnTranList" [subledgerDropDownList]="subledgerDropDownList" [TableAcHeader]="TableAcHeader" [trnaccountList]="accountListObersver$"></trntranentry>
</div>-->

<!--<div style="padding-bottom: 10px; margin-top: 10px;">
    <button *ngIf="viewMode==false" value="Save" (click)="onSave()" class="btn btn-primary">Save</button>
    <button value="Cancel" (click)="onCancelClicked()" style="margin-left: 4px;" class="btn btn-danger">Back</button>
</div>-->
